import { render } from "./ViewChapter.vue?vue&type=template&id=4aecaefd&scoped=true"
import script from "./ViewChapter.vue?vue&type=script&lang=js"
export * from "./ViewChapter.vue?vue&type=script&lang=js"

import "./ViewChapter.vue?vue&type=style&index=0&id=4aecaefd&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Callum\\Desktop\\k1890584_watkins_callum_code\\mo-books\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aecaefd"]])

export default __exports__